module.exports = __webpack_public_path__ + "static/media/microscopy-nsit0108-01 9.684f9bd0.png";